export const StatutCommandeLabels = {
    A_VALIDER: "À valider",
    VALIDE:    "Validée",
};

export const StatutCommandeValues = Object.fromEntries(
    Object.entries(StatutCommandeLabels).map(([key]) => [key, key])
);
